var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTooltipInfoCircle = function SvgTooltipInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00433F",
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.764 3.406q.287 0 .485.202a.67.67 0 0 1 .199.488.66.66 0 0 1-.202.482.66.66 0 0 1-.482.202.67.67 0 0 1-.488-.202.66.66 0 0 1-.202-.482q0-.287.202-.488a.67.67 0 0 1 .488-.202m-1.49 3.57V6.63q1.185-.134 1.99-.513l.135.098q-.05 1.3-.05 1.99v1.11q.031 1.587.037 1.716.007.305.068.445.03.055.079.095a.4.4 0 0 0 .146.064q.037.006.678.018V12a34 34 0 0 0-1.483-.043q-.489 0-1.6.043v-.348l.58-.006a.45.45 0 0 0 .199-.046.3.3 0 0 0 .107-.1q.067-.123.085-.434 0-.08.037-1.752V8.24q0-.909-.061-1.08a.25.25 0 0 0-.132-.137q-.094-.046-.814-.046",
    clipRule: "evenodd"
  })));
};
export default SvgTooltipInfoCircle;